var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.063rem",
    height: "2.063rem",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .aedit {\n                fill: #555;\n                stroke: #fff;\n                stroke-width: 0.125rem;\n            }\n\n            .bedit {\n                fill: #fff;\n            }\n\n            .cedit {\n                stroke: none;\n            }\n\n            .dedit {\n                fill: none;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-578 -204)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aedit",
    transform: "translate(578 204)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cedit",
    cx: 16.5,
    cy: 16.5,
    r: 16.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "bedit",
    d: "M4394.97,978.7a2.352,2.352,0,0,0-3.328,0l-6.1,6.1a.3.3,0,0,0-.087.175l-.452,3.347a.305.305,0,0,0,.086.256.31.31,0,0,0,.216.091.258.258,0,0,0,.041,0l2.017-.273a.307.307,0,1,0-.082-.608l-1.618.218.316-2.334,2.458,2.457a.308.308,0,0,0,.216.091.3.3,0,0,0,.215-.091l6.1-6.1a2.347,2.347,0,0,0,0-3.326Zm-3.209.749,1.025,1.024-5.569,5.565-1.023-1.024Zm-3.105,8.024-1-1,5.567-5.565,1,1Zm5.995-6-2.451-2.45a1.74,1.74,0,0,1,2.451,2.45Z",
    transform: "translate(-3795.999 -763.014)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fa83223a.svg";
export { ForwardRef as ReactComponent };